export const MOCK_AUTH_RESPONSE = {
    RESULT_CODE: "200",
    MESSAGE: "Success",
    SESSION_ID: "mock-session-123",
    MOBILE: "8446192253",
    ExistUser: true,
};

export const MOCK_FIPS = {
    lst: [
        { FIPID: "HDFC", FIPNAME: "HDFC Bank", LOGO: "hdfc.png", FITYPES: ["DEPOSIT"] },
        { FIPID: "ICICI", FIPNAME: "ICICI Bank", LOGO: "icici.png", FITYPES: ["DEPOSIT"] },
        { FIPID: "SBI", FIPNAME: "State Bank of India", LOGO: "sbi.png", FITYPES: ["DEPOSIT"] },
    ],
    RESULT_CODE: "200",
    RESULT_MESSAGE: "Success",
};

export const MOCK_ACCOUNTS = {
    ACC_LIST: [
        { ACC_ID: "acc-1", MASKED_ACC_NO: "XXXX-XXXX-1234", ACC_TYPE: "SAVINGS", FI_TYPE: "DEPOSIT", LINKED: false },
        { ACC_ID: "acc-2", MASKED_ACC_NO: "XXXX-XXXX-5678", ACC_TYPE: "CURRENT", FI_TYPE: "DEPOSIT", LINKED: true },
    ],
    RESULT_CODE: "200",
    RESULT_MESSAGE: "Success",
};

export const MOCK_CONSENT_HANDLE = {
    CONSENT_HANDLE: "mock-handle-999",
    PURPOSE: "Account aggregation for loan processing",
    FI_TYPES: ["DEPOSIT", "TERM_DEPOSIT"],
    DATA_RANGE_FROM: "2023-01-01",
    DATA_RANGE_TO: "2024-01-01",
    RESULT_CODE: "200",
};
